module.exports = __webpack_public_path__ + "static/media/centurion.970352cf.jpg";